import React from 'react';
import { useEffect } from "react";
import { Helmet } from 'react-helmet';
import "./style.css";
import Form from './Form.js'
import ContentWithImages from './ContentWithImages.js'
import DoctorBite from '../../DoctorBite.js';
import PatientReviews from '../../PatientReview.js';
import Faq from './Faq.js';
import GetInTouch from '../../GetInTouch.js';
import FollowYt from '../../FollowYt.js'
import Breadcrumb from '../../Breadcrum.js';

export default function Index() {
  useEffect(() => {
    const metaTags = document.getElementsByTagName('meta');
    Array.from(metaTags).forEach((tag) => {
      console.log(tag);
    });
  }, []);
  return (
    <div>
          <Helmet>
            <title>Best Turbinectomy Procedures in Delhi | MedFirst ENT Centre</title>
            <meta name="description" content="Explore the best turbinectomy and turbinoplasty procedures in Delhi. Book your ENT consultation today for expert evaluation.Dr (Major)Rajesh Bhardwaj." />
            <meta name="keywords" content="best turbinectomy procedures in Delhi" />
            <link rel="canonical" href="https://entdelhi.com/turbinoplasty/" />
            <meta property="og:title" content="Open Graph Title" />
            <meta property="og:description" content="Open Graph Description for Facebook etc." />
            <meta name="robots" content="index, follow" />
            {/* You can add more meta tags as needed */}
          </Helmet>
      <main>
        <Breadcrumb/>
        <Form />  
         <ContentWithImages/>
         <FollowYt/>
         <DoctorBite/>
         <PatientReviews/>
         <Faq/>
         <GetInTouch/>
      </main>
    </div>
  )
}
